import { render, staticRenderFns } from "./ContactVentura.vue?vue&type=template&id=52f833fe&scoped=true&"
import script from "./ContactVentura.vue?vue&type=script&lang=js&"
export * from "./ContactVentura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f833fe",
  null
  
)

export default component.exports